module.exports = __webpack_public_path__ + "img/Chailease Finance.6248e53a.png";